import React from "react";
import { Popover } from "antd";
import shiftAccept from "../../../../assets/svg/shiftAccept.svg";
import shiftAsterisk from "../../../../assets/svg/shiftAsterisk.svg";
import greenStar from "../../../../assets/svg/grayStar.svg";
import { defaultProfile } from "components/pages/talents/talentListNew/helper";
import _ from "lodash";
import { roleStatsColor } from "constants/shifts";

const RoleExpandableRow = ({
  record,
  baseUrl,
}) => {
  let roleStats = "";
  let statsColor = "";
  let statsFontColor = "";

  if (record?.stats) {
    if (record?.stats?.understaffed) {
      roleStats = "Understaffed";
      statsColor = roleStatsColor.yellow;
      statsFontColor = "text-darkRed"
    } else if (record?.stats?.approved > record.talent_needed) {
      roleStats = "Overstaffed";
      statsColor = roleStatsColor.pink;
      statsFontColor = "text-heliotropePink"
    } else {
      roleStats = "Fully Staffed";
      statsColor = roleStatsColor.green;
      statsFontColor = "text-algae"
    }
  }

  return (
    <div>
      <div className="flex justify-between">
        <div className="flex justify-around items-center">
          <div className="flex items-center">
            <span className="text-grayBlack text-xs font-bold">Staffing</span>
          </div>
          <div className="flex items-center mx-4">
            <Popover
              placement="top"
              content={
                <span className="text-black text-[13px] font-medium">
                  Staff confirmed
                </span>
              }
              popupClassName="event-shift-popover"
            >
              <div className="flex">
                <img src={shiftAccept} alt="shift-send" className="mr-[6px]" />
                <span
                  className={`text-[13px] font-bold ${
                    statsFontColor
                  }`}
                >
                  {record?.stats?.approved}
                </span>
              </div>
            </Popover>
            <span className="text-silverGray mx-[6px]">/</span>
            <Popover
              placement="top"
              content={
                <span className="text-black text-[13px] font-medium">
                  Staff needed
                </span>
              }
              overlayClassName="event-shift-popover"
            >
              <div className="flex">
                <img
                  src={shiftAsterisk}
                  alt="shift-send"
                  className="mr-[6px]"
                />
                <span
                  className={`text-[13px] font-bold ${
                    statsFontColor
                  }`}
                >
                  {record?.talent_needed}
                </span>
              </div>
            </Popover>
          </div>

          <span
            className={`border border-transparent rounded-[4px] py-[2px] px-[3px] text-subText font-medium ${statsColor}`}
          >
            {roleStats}
          </span>
        </div>
      </div>

      <div className="max-h-[235px] overflow-auto">
        {record?.people?.length > 0 ? (
          record.people
            .filter(p => p?.status === "approved")
            .map((p, index) => {
              const imageStyle =
                "w-[32px] min-w-[32px] max-w-[32px] h-[35px] rounded-[6px]";

              return (
                <div
                  className={`flex justify-between p-4 ${
                    index !== 0 && "border-t-[1px] border-t-[#F2F2F2]"
                  }`}
                  key={p?.uuid}
                >
                  <div className="role-person-container">
                    <div>
                      {p?.person?.primary_photo_attribute?.value ? (
                        <img
                          src={
                            baseUrl + p?.person?.primary_photo_attribute?.value
                          }
                          alt="profile"
                          width={32}
                          height={32}
                          className={imageStyle}
                          onError={(e) => (e.target.src = defaultProfile)}
                        />
                      ) : (
                        <img
                          className={imageStyle}
                          src={defaultProfile}
                          alt="Profile not Found"
                        />
                      )}
                    </div>

                    <div>
                      <p className="text-black text-sm font-medium font-inter">
                        {p?.person?.first_name + " " + p?.person?.last_name}
                      </p>
                      <p className="text-cadetBlue font-medium text-sm font-inter">
                        {_.startCase(
                          _.toLower(
                            p?.person?.primary_address?.state_province?.name
                          )
                        )}{" "}
                        {" "}
                        {_.startCase(
                          _.toLower(
                            p?.person?.primary_address?.state_province?.country
                              ?.name
                          )
                        )}
                      </p>
                    </div>

                    <div className="flex">
                      <img src={greenStar} alt="rating-star" />
                      <span className="ml-1 font-normal text-sm font-inter text-grayBlack">
                        {p?.person?.company_rating || "Unrated"}
                      </span>
                    </div>

                    <div className="text-right">
                      <p className="font-bold text-sm font-inter text-darkMintGreen">
                        Approved
                      </p>
                    </div>
                  </div>
                </div>
              );
            })
        ) : (
          <p className="font-inter mt-4 ml-3 font-medium">
            No people was found
          </p>
        )}
      </div>
    </div>
  );
};

export default RoleExpandableRow;
